module.exports = __webpack_public_path__ + "static/media/mental-health.f80e872b.png";